/* eslint-disable */
import requestRaw from '@/utils/requestRawBasic'
import { APICore } from '@/utils/servicesApi'

export function confirm(data) {
  return requestRaw({
    url: APICore() + '/member/otp/confirm',
    method: 'POST',
    data: data // untuk array data post
  })
}


// WEBPACK FOOTER //
// ./src/api/otp.js